import React from 'react';
import AuthButton from '../../Buttons/AuthButton';
import './CommunityListLC.scss';
import * as ROUTES from '../../../routes';
import ImageWebp from '../../../utils/imageProcess/ImageWebp'


function CommunityList(props) {
  return (
    <section>
      <div className="lc-communityl-wrapper">
        <div className="ListImage">
        <ImageWebp
                srcWebp={'./img/LandingClient/background/persona-para-fondo-3.webp'}
                src={'./img/LandingClient/background/persona-para-fondo-3.png'}
                alt="Despachos de Abogados en México"
              /> 
        </div>
        <div className="ListDescription">
          <img src="./img/LandingClient/background/b.svg" alt="Despachos de Abogados en México" />
          <p className="ListDescription-title">
            Te ayudamos a encontrar al especialista que requieres para la solución a tus problemas legales.
          </p>
          <p className="ListDescription-subtitle">Encuentra al abogado ideal para resolver tu situación legal</p>

          <AuthButton
            direction={ROUTES.SEARCH_LAWYER + 'Abogados'}
            variant="outlinedBlue"
            style={{ width: '256px' }}
          >
            Buscar abogado
          </AuthButton>
        </div>
      </div>
    </section>
  );
}

export default CommunityList;
